export class UtilsService {
  constructor () {
    'ngInject';
  }

  blockMatch(mapper) {
    let matchBlock = false;
    if(mapper.find( x => x.edited )){
      matchBlock = true;
    }
    return matchBlock;
  }
}